import axios from 'axios'
import store from '../store'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  getNavMenu({ state }) {
    // let api = endpoint
    // console.log(api)
    let url = `${appConfig.apiEndPoint}${endpoint.adminApiPath.getMenuACL}`
    return axios.get(url, {
      headers: setHeaders(),
    })
  },
}
function setHeaders() {
  const path = window.location.href
  const url = path.includes('vod-otpscreen')
  if (url) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
